module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-vodafonereb-00.2@2x.57fe0298.jpg";